export default __webpack_public_path__ + "static/media/mail-icon.4f4b64ff.svg";